import { LogicalOperand } from './operand.entity';
import { AdvancedSearch, StructuredQuery } from './structured-query.entity';

export const EmptyAdvancedSearch: AdvancedSearch = {
    LogicalOperand: LogicalOperand.And,
    Groups: []
};

export const EmptyStructuredQuery: StructuredQuery = {
    Global: [],
    Semantic: '',
    FullText: '',
    AdvancedSearch: EmptyAdvancedSearch,
    Facets: [],
    Fields: [],
    ColumnFilters: []
};
